module.exports = __webpack_public_path__ + "media/images/demo_tests/pincode-bb837f4b3c4b7820b474e0cbef8df493.png";